import React from 'react';
import type { ImageEnrichmentProgress } from '../services/api';
import './ImageEnrichmentStatus.css';

/** Independent search readiness never changes the main analysis status. */
const ImageEnrichmentStatus: React.FC<{ progress?: ImageEnrichmentProgress }> = ({ progress }) => {
  if (!progress || progress.status === 'disabled' || progress.total <= 0) return null;
  const label = progress.status === 'completed'
    ? 'Image search ready'
    : progress.status === 'failed'
      ? `Image search: ${progress.completed}/${progress.total} ready · ${progress.failed} failed`
      : `Preparing image search · ${progress.completed}/${progress.total} ready`;
  return <small className="image-enrichment-status" role="status">{label}</small>;
};

export default ImageEnrichmentStatus;
